/* FurCasa Home — responsive, continuous left-to-right announcement ribbon.
   Keep existing appearance/content in top-bar3.liquid. The script only measures
   content and creates equal-width sequences for a gapless CSS animation. */
(function () {
  'use strict';
  var instances = new WeakMap();

  function rebuild(bar) {
    var marquee = bar.querySelector('[data-fc-marquee]');
    var track = bar.querySelector('[data-fc-marquee-track]');
    var group = bar.querySelector('[data-fc-marquee-group]');
    if (!marquee || !track || !group) return;

    var first = group.querySelector('.fc-marquee-item');
    if (!first) return;

    // Stop animation only during an actual change of the visible ribbon width.
    track.removeAttribute('data-fc-ready');
    // Some browsers do not support replaceChildren: keep this fully compatible.
    while (group.children.length > 1) group.lastElementChild.remove();
    Array.from(track.children).forEach(function (node) {
      if (node !== group) node.remove();
    });

    var messageWidth = first.getBoundingClientRect().width;
    var visibleWidth = marquee.getBoundingClientRect().width;
    if (visibleWidth < 1 || messageWidth < 1) return;

    // Each sequence is wider than the visible area, with a full duplicate
    // following it. Translating precisely one sequence is an invisible loop.
    var count = Math.max(2, Math.ceil(visibleWidth / messageWidth) + 1);
    for (var i = 1; i < count; i++) {
      var copy = first.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('a').forEach(function (link) { link.tabIndex = -1; });
      group.appendChild(copy);
    }
    var duplicate = group.cloneNode(true);
    duplicate.removeAttribute('data-fc-marquee-group');
    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.querySelectorAll('a').forEach(function (link) { link.tabIndex = -1; });
    track.appendChild(duplicate);

    // 70 px/sec makes motion visible at desktop sizes but keeps it smooth.
    var distance = group.getBoundingClientRect().width;
    var speed = Number(bar.dataset.fcMarqueeSpeed) || 70;
    track.style.setProperty('--fc-marquee-duration', Math.max(9, distance / speed).toFixed(2) + 's');
    track.setAttribute('data-fc-ready', 'true');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fc-marquee]').forEach(function (marquee) {
      var bar = marquee.closest('.top-bar3');
      if (!bar || instances.has(bar)) return;
      var lastWidth = 0;
      var instance = { observer: null };
      instances.set(bar, instance);

      function checkWidth() {
        var width = Math.round(marquee.getBoundingClientRect().width);
        // Tiny changes of 0-1px should not reset the animation endlessly.
        if (width < 1 || Math.abs(width - lastWidth) < 3) return;
        lastWidth = width;
        rebuild(bar);
      }
      checkWidth();
      if ('ResizeObserver' in window) {
        instance.observer = new ResizeObserver(function () { checkWidth(); });
        instance.observer.observe(marquee);
      } else {
        window.addEventListener('resize', checkWidth, { passive: true });
      }
      // Fonts can change message widths without changing the viewport width.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { if (bar.isConnected) rebuild(bar); });
      }
    });
  }

  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.top-bar3').forEach(function (bar) {
      var instance = instances.get(bar);
      if (instance && instance.observer) instance.observer.disconnect();
      instances.delete(bar);
    });
  });
})();
